import styled, { css } from 'styled-components';

import type { ColorKeys } from '@/theme/types/colors';

import { Box } from '../Box';
import { Flex } from '../Flex';
import type { TableAlign } from './Table';

const commonStyles = css`
  min-height: 52px;
`;

export const Table = styled.table`
  width: 100%;
  overflow-x: auto;
`;

export const TableTitleWrapper = styled(Flex)<{
  $hasBodyText: boolean;
  $height?: string;
}>`
  ${commonStyles}
  ${({ $hasBodyText, $height, theme }) => css`
    padding: ${theme.spacing(2)};
    ${$height &&
    css`
      height: ${$height};
    `}
    background-color: ${theme.colors.primaryDark};
    justify-content: center;
    flex-direction: column;
    ${theme.media.sm.up} {
      flex-direction: row;
      justify-content: ${$hasBodyText ? 'space-between' : 'center'};
    }
  `}
`;

export const TableTitleBodyTextWrapper = styled(Box)`
  ${({ theme }) => css`
    text-align: center;
    ${theme.media.sm.up} {
      text-align: right;
    }
  `}
`;

export const TableHead = styled.thead<{ $color: ColorKeys }>`
  th,
  td {
    ${({ $color, theme }) => css`
      background-color: ${theme.colors.primaryDark};
      color: ${theme.colors[$color]};
    `}
  }
  th {
    text-transform: uppercase;
  }
`;

export const TableCell = styled.td<{
  $align: TableAlign;
  $lightGrey?: boolean;
}>`
  ${commonStyles}
  vertical-align: middle;
  ${({ $align, $lightGrey, theme }) => css`
    padding: ${theme.spacing(2)};
    text-align: ${$align};
    font-size: ${theme.fontSizes.h6};
    font-weight: ${theme.fontWeights.medium};
    font-family: ${theme.fontFamilies.italianPlate};
    border: 1px solid ${theme.colors.mediumGrey};
    ${$lightGrey &&
    css`
      background-color: ${theme.colors.secondaryLightGrey};
    `}
  `}
`;
